.page {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 40px;
  background: var(--bg);
}

.addRow {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.addRow input {
  width: 240px;
}

.error {
  margin: 0 32px 16px;
  padding: 10px 14px;
  font-size: 13.5px;
  color: var(--err);
  background: var(--err-bg);
  border-radius: var(--r-sm);
}

.emptyBox {
  max-width: 560px;
  margin: 0 32px;
  padding: 28px;
  background: var(--card-bg);
  border: 1px dashed var(--border);
  border-radius: var(--r-lg);
}

.emptyTitle {
  font-size: 17px;
  font-weight: 600;
  color: var(--text);
}
.emptyText {
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text2);
}

/* ── Рейтинг ── */
.tableWrap {
  margin: 0 32px;
  overflow-x: auto;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}

.table {
  width: 100%;
  font-size: 14px;
  border-collapse: collapse;
}

.table th {
  padding: 11px 14px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text2);
  text-align: left;
  white-space: nowrap;
  box-shadow: inset 0 -1px 0 var(--border);
}

.table td {
  padding: 12px 14px;
  color: var(--text);
  vertical-align: middle;
  border-bottom: 1px solid var(--border);
}

.table tbody tr {
  cursor: pointer;
}
.table tbody tr:last-child td {
  border-bottom: none;
}
.table tbody tr:hover td,
.table tbody tr:focus-visible td {
  background: var(--table-hover);
}
.table tbody tr:focus-visible {
  outline: 2px solid var(--blue);
  outline-offset: -2px;
}

.rankCol {
  width: 72px;
}

.rank {
  display: inline-grid;
  place-items: center;
  min-width: 28px;
  height: 28px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text2);
  background: var(--table-even);
  border-radius: 50%;
  font-variant-numeric: tabular-nums;
}

.rankTop {
  color: var(--ok);
  background: var(--ok-bg);
}
.rankLow {
  color: var(--err);
  background: var(--err-bg);
}

.name {
  font-weight: 600;
  white-space: nowrap;
}

.barCol {
  width: 34%;
  min-width: 220px;
}

.completion {
  display: flex;
  align-items: center;
  gap: 12px;
}

.track {
  flex: 1;
  height: 8px;
  overflow: hidden;
  background: color-mix(in srgb, var(--led-open) 30%, var(--card-bg));
  border-radius: var(--r-bar);
}

.fill {
  display: block;
  height: 100%;
  background: var(--led-clean);
  border-radius: var(--r-bar);
}

.pct {
  min-width: 56px;
  font-weight: 600;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.num {
  text-align: right !important;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.share {
  display: block;
  font-size: 12px;
  color: var(--text2);
}

.warnValue {
  color: var(--warn);
  font-weight: 600;
}

.meta {
  display: none;
}

.actionsCol {
  width: 48px;
  text-align: right;
}

.delete {
  width: 30px;
  height: 30px;
  font-size: 18px;
  line-height: 1;
  color: var(--text2);
  background: none;
  border: 1px solid transparent;
  border-radius: var(--r-sm);
  cursor: pointer;
}

.delete:hover {
  color: var(--err);
  border-color: var(--border);
  background: var(--card-bg);
}

@media (max-width: 699px) {
  .error,
  .emptyBox,
  .tableWrap {
    margin-left: 16px;
    margin-right: 16px;
  }
  .addRow,
  .addRow input {
    width: 100%;
  }

  /* Рейтинг становится списком: место, дивизион, заполненность, числа строкой */
  .tableWrap {
    overflow: visible;
  }
  .table,
  .table tbody,
  .table td {
    display: block;
  }
  .table thead,
  .table .num {
    display: none;
  }
  .table tbody tr {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr) auto;
    align-items: center;
    column-gap: 12px;
    padding: 12px 14px;
    border-bottom: 1px solid var(--border);
  }
  .table tbody tr:last-child {
    border-bottom: none;
  }
  .table td {
    padding: 0;
    border: none;
  }
  .table tbody tr:hover,
  .table tbody tr:focus-visible {
    background: var(--table-hover);
  }
  .table tbody tr:hover td,
  .table tbody tr:focus-visible td {
    background: none;
  }
  .rankCol {
    width: auto;
  }
  .name {
    white-space: normal;
  }
  .barCol {
    grid-column: 1 / -1;
    grid-row: 2;
    width: auto;
    min-width: 0;
    margin-top: 10px;
  }
  .actionsCol {
    width: auto;
  }
  .meta {
    display: block;
    margin-top: 6px;
    font-size: 12.5px;
    color: var(--text2);
    font-variant-numeric: tabular-nums;
  }
  .meta .warnValue {
    font-weight: 500;
  }
}
